import { CloudDownload, Print } from "@mui/icons-material";
import { Box, Button, Card, createTheme, FormLabel, Grid, Icon, styled, ThemeProvider } from "@mui/material";
import { Loader } from "app/components";
import { getOngoingProjectDetailsForLandingPage } from "app/redux/actions/ProjectLocationActions";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { checkValidation, currencyFormat, formatNumberWithCommasAndDecimals } from "app/utils/utils";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import MUIDataTable from 'mui-datatables';
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const Container = styled("div")(({ theme }) => ({
  margin: "30px",
  [theme.breakpoints.down("sm")]: { margin: "16px" },
  "& .breadcrumb": {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
  },
}));

const theme = createTheme({

  components: {
    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          backgroundColor: "#87CEEB",
        }
      }
    }
  }
});


export const OngoingProjectsReport = () => {

const columns = [
    {
        name: "index",
        label: "Sl. No",
        options: {
        filter: false,
        // customHeadRender: () => {
        //     return (
        //     <th style={{ textAlign: 'right', backgroundColor: '#efefef', verticalAlign: 'center' }}>Sl. No</th>
        //     );
        // },
        customBodyRenderLite: (dataIndex) => (
            <span style={{ fontSize: '13px' }}>{dataIndex + 1}</span>
        ),
        // setCellProps: () => ({
        //     style: {
        //     textAlign: 'center',
        //     width: '3%',
        //     },
        // }),
        // },
        }
    },
    {
        name: "agency_name",
        label: "Agency Name",
        options: {
        filter: true,
        // customHeadRender: () => {
        //     return (
        //     <th style={{ textAlign: 'left', backgroundColor: '#efefef' }}>Agency Name</th>
        //     );
        // },
        customBodyRender: (value) => (
            <span style={{ fontSize: '12px' }}><div className="description-cell">{value}</div></span>
        ),
        // setCellProps: () => ({
        //     style: {
        //     textAlign: 'left',
        //     width: '15%',
        //     },
        // }),
        },
    },
    {
        name: "project_name",
        label: "Project Name",
        options: {
        filter: true,
        // customHeadRender: () => {
        //     return (
        //     <th style={{ textAlign: 'left', backgroundColor: '#efefef' }}>Project Name</th>
        //     );
        // },
        customBodyRender: (value) => (
            <span style={{ fontSize: '12px' }}>{value}</span>
        ),
        // setCellProps: () => ({
        //     style: {
        //     textAlign: 'left',
        //     width: '15%',
        //     },
        // }),
        },
    },
    {
        name: "company",
        label: "Company Name",
        options: {
        filter: true,
        // customHeadRender: () => {
        //     return (
        //     <th style={{ textAlign: 'left', backgroundColor: '#efefef' }}>Company Name</th>
        //     );
        // },
        customBodyRender: (value) => (
            <span style={{ fontSize: '12px' }}>{value}</span>
        ),
        // setCellProps: () => ({
        //     style: {
        //     textAlign: 'left',
        //     width: '10%',
        //     },
        // }),
        },
    },
    {
        name: "contract_amount",
        label: "Approved Budget (M)",
        options: {
        filter: true,
        // customHeadRender: () => {
        //     return (
        //     <th style={{ textAlign: 'center', backgroundColor: '#efefef' }}>Amount(Nu-in million)</th>
        //     );
        // },
        customBodyRender: (value) => (
            <span style={{ fontSize: '12px' }}>{currencyFormat(value)}</span>
        ),
        // setCellProps: () => ({
        //     style: {
        //     textAlign: 'center',
        //     width: '15%',
        //     },
        // }),
    }
    },
];

  const dispatch = useDispatch();
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [projectDetails, setProjectDetails] = useState()
  const [reportType, setReportType] = useState("PR")
  const [totalAmount, setTotalAmount] = useState()
  const { ongoingProjectList } = useSelector((state) => state.projectLocation);

  const [state, setState] = useState({
    project_location_id: '',
  })

  useEffect(() => {
      dispatch(getOngoingProjectDetailsForLandingPage(handleSuccess, showLoader, hideLoader, showToast))
}, []);

const handleSuccess = () => {

}

  const showLoader = () => {
    setLoading(true)
  }

  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }

  const handleReportDownload = (isPrint) => {
    const doc = new jsPDF();
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    } else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
    
    const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
      const textX = 15;
      const textY = headerHeight

      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(10); // Set font size 

      doc.text("ONGOING PROJECT DETAILS", (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth("STATEMENT OF MATERIAL FORECAST") * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);


      doc.setFontSize(8); // Set font size

      doc.setFont('helvetica', 'normal');

      const headerSectionHeight = headerHeight+15; // Adjust the value as needed

      // Calculate the starting Y-coordinate for the table
      const tableStartY = headerSectionHeight + 5;
      doc.setFont('helvetica', 'normal');
      const body = []


      ongoingProjectList && ongoingProjectList?.length > 0 && ongoingProjectList?.forEach((elem, index) => {

        body.push(
          [
          { content: index + 1,styles:{fontSize:8}},
          { content:elem?.agency_name ?? "",styles:{fontSize:8}},
          { content: elem?.project_name ?? "", styles: { halign: "right",fontSize:8 } },
          { content: elem?.company ?? "", styles: { halign: "center",fontSize:8 } },
          { content: currencyFormat(elem?.contract_amount), styles: { halign: "right",fontSize:8 } },
          ]
        )
      })
    
      doc.autoTable({
         margin: { 
          top: 30,      // push below header
          bottom: 30    // leave space above footer
        },
        startY: tableStartY,
        head: [[
          { content: "Sl No.", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Agency Name", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Project Name", colSpan: 1, styles: { valign: "middle", halign: "right", cellPadding: 2, fontSize: 8 } },
          { content: "Company Name", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Contract Amount (Nu)", colSpan: 1, styles: { valign: "middle", halign: "right", cellPadding: 2, fontSize: 8 } }
        ]],
        body: body, // Use the transformed data here
        theme: "grid",
        styles: {
          fillColor: [255, 255, 255], // Remove background color from the table
          lineColor: [0, 0, 0], // Set border color for main table
          lineWidth: 0.1, // Set border width for main table
          textColor: [0, 0, 0], // Set text color to black
          cellPadding: 2, // Add padding to cells
        },
        columnStyles: {
          1: { cellWidth: 50 }, // "ITEM DESCRIPTION" column width
        },
      });

     const totalNumPages = doc.internal.getNumberOfPages();

      // Loop through each page to add the footer with page numbers
      for (let i = 1; i <= totalNumPages; i++) {
  
        const pdfWidth = doc.internal.pageSize.getWidth() - 30;
  
        // Header
        const headerHeight = 20;
        const headerX = 15;
        const headerY = 0; // at the very top
        if (checkValidation(projectDetails?.header)) {
          doc.addImage(
            `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
            headerX,
            headerY,
            pdfWidth,
            headerHeight
          );
        }
  
        //Footer
        const footerX = 15; // Starting X position for the footer
        const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
        const footerHeight = 20;
        doc.setPage(i);
        if (checkValidation(projectDetails?.footer)) {
          doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
        }
      }

      const scaleFactor = 1.0; // Adjust this value as needed
      const pdfBlob = doc.output('blob', { scale: scaleFactor });

      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open a new window with the PDF URL

      if (isPrint) {
        const newWindow = window.open(pdfUrl, '_blank');

        // After the new window is opened, you can close the URL object
        URL.revokeObjectURL(pdfUrl);
        if (newWindow) {
          newWindow.onload = () => {
            setIsPrinting(false)
            setIsDownloading(false)
            // Wait for the window to load and then trigger the print dialog
            newWindow.print();
          };
        }
      }

      setIsPrinting(false)
      setIsDownloading(false)

      isPrint === false && doc.save('Ongoing_Projects_Report.pdf');
  };

  return (
    <Container>

      <div style={{ height: 'auto', width: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>

        <Grid container>

          <Grid item xs={12}>
            <Button
              size="small"
              sx={{ width: "100px" }}
              variant="contained"
              color="error"
              onClick={() => { window.history.back() }}
            >
              <Icon color="primary" fontSize="small">
                skip_previous
              </Icon>
              Back
            </Button>
          </Grid>
        </Grid>
        {
          ongoingProjectList && ongoingProjectList?.length > 0 &&
          <Grid container>
            <Grid xs={12} md={6}>
              {/* {checkValidation(state?.header) === false && <FormLabel sx={{ color: "#ff9800" }} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="span" display="flex" justifyContent="flex-end">
                <Button
                  size="small"
                  sx={{ width: "130px", marginLeft: 4 }}
                  variant="contained"
                  // disabled={state?.header ? false : true}
                  color="warning"
                  startIcon={<CloudDownload />}
                  onClick={() => { handleReportDownload(false) }}
                >
                  Download
                </Button>
                <Button
                  size="small"
                  sx={{ width: "100px", marginLeft: 2 }}
                  variant="contained"
                  // disabled={state?.header ? false : true}
                  color="primary"
                  startIcon={<Print />}
                  onClick={() => { handleReportDownload(true) }}
                >
                  Print
                </Button>
              </Box>
            </Grid>

          </Grid>}
        {/* table */}
        {
          ongoingProjectList && ongoingProjectList?.length > 0 &&
          <Card sx={{ padding: 3 }}>

            <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
              <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
                  {checkValidation(projectDetails?.header) && 
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                  }
                </div>

                <Grid container >
                  <Grid item xs={12} align='center' >
                    <FormLabel sx={{ fontSize: 22 }} ><b>ONGOING PROJECT DETAILS</b></FormLabel>
                  </Grid>
                </Grid>
              </div>

              <div id="tableData" style={{ overflowX: 'auto' }}>
                <ThemeProvider theme={theme}>
                <MUIDataTable
                    data={ongoingProjectList}
                    columns={columns}
                    title={""}
                    options={{
                        fixedHeader: true,
                        responsive: 'scroll',
                        selectableRows: "none",
                        elevation: 0,
                        sort: false,
                        search: false, // set search option
                        filter: false, // set data filter option
                        download: false, // set download option
                        print: false, // set print option
                        pagination: true, //set pagination option
                        viewColumns: false,
                        rowsPerPageOptions: [5, 10, 20, 50],
                        rowsPerPage: 20, // Set the default number of rows per page
                    }}
                    className="fixed-height-table"
                />
                </ThemeProvider>

                </div>
                </div>
            </Card>
            }

      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please Wait."
        />
      )}

    </Container>

  )
}